import * as React from 'react';

import { Lottie, ReactLottieConfig } from '@crello/react-lottie';
import animationData from './data.json';

interface LogoLoadingCtrlProps {
  className?: string;
  loading?: boolean;
  width?: string;
  height?: string;
}

export const LogoLoadingCtrl: React.FC<LogoLoadingCtrlProps> = (props) => {
  const defaultOptions: ReactLottieConfig = {
    loop: true,
    autoplay: false,
    renderer: 'svg',
    animationData: JSON.parse(JSON.stringify(animationData)),
  };

  return (
    <Lottie
      className={props.className}
      config={defaultOptions}
      height={props.height || '200px'}
      width={props.width || '200px'}
      playingState={!props.loading ? 'paused' : 'playing'}
      // isClickToPauseDisabled={true}
    />
  );
};

export default LogoLoadingCtrl;
